<style scoped>
.h-btn {
    min-width: 200px;
}

.no-href-dec {
    text-decoration: none;
    cursor: pointer;
}

.branch-select {
    min-width: 200px
}

.search_field{
    padding: 10px;
}

._btn {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    padding: 7px 12px;
}

._btn {
    margin: 0 !important;
    line-height: 1;
    color:#fff;
}
</style>
<template>
    <!-- Content -->
    <div class="content-wrapper">
        <div class="row mb-3">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-12 d-flex justify-content-between">
                        <h3 class="font-weight-bold text-capitalize">Services By {{ staff.username }}</h3>
                        <button class="btn btn-primary" @click="goBack">
                            <i class="fa fa-arrow-left"></i>
                            Back
                        </button>
                    </div>

                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                 <div class="row mb-3">
                     <div class="col-sm-12 col-md-3 col-12 stretch-card col-grid">
                        <input type="text" v-model="this.filter_parcel" class="form-control"
                                placeholder="Search to filter service">
                     </div>
                     <div class="col-sm-12 col-md-3 col-12 stretch-card col-grid"></div>
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
 <input class="date_input form-control" v-model="this.fdate" type="date">
                    </div>
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                         <input class="date_input form-control" type="date" v-model="this.tdate">
                    </div>
                    
                  
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                         <button id="filter_btn" @click="filterParcels" class="btn btn-primary simple-btn">Filter</button>
                    </div>
                    
                </div>

                  <div class="row">
                        <div class="col-12">
                            <h4 class="my-3 text-center">{{heading}}</h4>
                              <div v-if="loading" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>
                <div class="table-responsive">
                    
                    <table class="table table-striped mt-3">
                        <thead>
                            <tr class="thead-style">
                                <th>No</th>
                                <th> Parcel Name</th>
                                <th>Price</th>
                                <th> Receiver  </th>
                                <th  v-if="user.role == 4"> Sender </th>
                                <th> From - To </th>
                                <th  v-if="user.role < 4"> Served By </th>
                                <th> Sent - Served </th>
                                <th> Action </th>
                            </tr>
                        </thead>
                        <tbody id="incoming-list">

                            <tr v-for="(parcel, index) in paginatedParcels" :key="parcel.id" :id="'parcel_'+parcel.id">
                                <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                               
                                 <td class="text-capitalize">
                                    <span class="d-block">{{ parcel.name }}</span>
                                    <span class="d-block mt-1 text-muted">{{ parcel.tag_name }}</span>
                                </td>
                                <td><label class="badge badge-dark"><PriceFormat :Price="parcel.price"/></label></td>
                                <td class="text-capitalize">
                                    <span class="d-block">{{ parcel.receiver_name }}</span>
                                    <span class="d-block mt-1 text-muted">{{ parcel.receiver_phone }}</span>
                                </td>
                                <td  v-if="user.role == 4" class="text-capitalize">
                                    <span class="d-block">{{ parcel.sender_name }}</span>
                                    <span class="d-block mt-1 text-muted">{{ parcel.sender_phone }}</span>
                                </td>
                                 <td class="text-capitalize">
                                    <span class="d-block">{{ parcel.branch_from_name }}</span>
                                    <span class="d-block mt-1 text-muted">{{ parcel.branch_to_name }}</span>
                                </td>
                               <td  v-if="user.role < 4" class="text-capitalize">
                                    <span class="d-block">{{ parcel.fulname }}</span>
                                    <span class="d-block mt-1 text-muted">{{ parcel.phone1 }}</span>
                                </td>
                                <td class="text-capitalize">
                                    <span class="d-block"><DateFormat :Date_="parcel.sent_at"/></span>
                                    <span class="d-block mt-1 text-muted"><DateFormat :Date_="parcel.created_at"/></span>
                                </td>
            
                                <td>
                                    <label v-if="parcel.type == 0" class="badge badge-info">Picked</label>
                                    <label v-if="parcel.type == 1" class="badge badge-warning">Hapokei</label>
                                    <label v-if="parcel.type == 2" class="badge badge-danger">Hapatikani</label>
                                     <label v-if="parcel.type == 3" class="badge badge-primary">Kapokea</label>
                                    <label v-if="parcel.type == 4" class="badge badge-success">Completed</label>
                                    <span class="m-1"></span>
                                    <button type="button" @click="getReceiveParcel(parcel)"
                                        class="_btn btn receive_btn btn-primary">
                                        {{ parcel.events }} Events
                                    </button>
                                </td>
                            </tr>
                          
                        </tbody>
                    </table>
                </div>
                           <div class="pagination-wrapper">

  <button 
    @click="currentPageP--"
    :disabled="currentPageP === 1">
    Prev
  </button>

  <button
    v-for="page in totalPagesP"
    :key="page"
    @click="currentPageP = page"
    :class="{ active: currentPageP === page }">
    {{ page }}
  </button>

  <button
    @click="currentPageP++"
    :disabled="currentPageP === totalPagesP">
    Next
  </button>

</div>
                        </div>
                    </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div v-if="loading" class="mt-1">
                    <div class="text-center">
                        <div class="spinner-grow text-success" role="status"></div>
                        <div class="spinner-grow text-danger" role="status"></div>
                        <div class="spinner-grow text-warning" role="status"></div>
                    </div>
                </div>

            </div>
        </div>

        <div class="row">
            <div class="col-12">

                <h4 class="py-4">Staff Details & Branches Manipulations</h4>

                <div class="card-body">

                    <div class="row mb-3">
                        <div class="col-sm-12 col-md-8 col-12">

                            <div class="row">

                                <!-- Staff Information -->
                                <div class="col-sm-12 col-md-6 mb-4">

                                    <div class="staff-card">

                                        <!-- Avatar -->
                                        <div class="staff-avatar-wrapper">
                                            <img :src="$store.state.img_url + user.avator" alt="Staff Avatar"
                                                class="staff-avatar">
                                        </div>

                                        <!-- Staff Details -->
                                        <div class="staff-info">

                                            <h5 class="staff-name text-capitalize">
                                                {{ staff.fulname }}
                                            </h5>

                                            <div class="staff-detail">
                                                <span>Username :</span>
                                                <span><b class="">{{ staff.username }}</b></span>
                                            </div>

                                            <div class="staff-detail">
                                                <span>Phone no :</span>
                                                <span><b class="text-capitalize">{{ staff.phone1 }}</b></span>
                                            </div>

                                            <div class="staff-detail">
                                                <span>Branch :</span>
                                                <span><b class="text-capitalize">{{ staff.branch_name }}</b></span>
                                            </div>

                                            <div class="staff-detail">
                                                <i class="fa fa-code-branch"></i>
                                                <span>
                                                    <b>{{ this.staff_branches.length }}</b> Assigned Branches
                                                </span>
                                            </div>

                                        </div>

                                    </div>

                                </div>


                                <!-- Branches -->
                                <div class="col-sm-12 col-md-6 mb-4">

                                    <div class="branch-table">

                                        <h5 class="mb-1 pt-3 mx-3">
                                            Assigned Branches
                                        </h5>

                                        <div class="table-responsive">

                                            <table class="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>No</th>
                                                        <th>Branch Name</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody id="staff-list">

                                                    <tr v-for="(branch, index) in staff_branches" :key="branch.id">
                                                        <td>
                                                            {{ index + 1 }}
                                                        </td>

                                                        <td>
                                                            {{ branch.name }}
                                                        </td>

                                                        <td>
                                                            <button :disabled="loading_action" @click="manibulateBranch(branch, type = 0)" type="button"
                                                                class="btn btn-danger btn-sm text-white">
                                                                <i class="fa fa-trash"></i>
                                                                Remove
                                                            </button>
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>


                        <div class="col-sm-12 col-md-4 col-12">
 <div class="branch-table">

                                        <h5 class="mb-1 pt-3 mx-3">
                                            UnAssigned (Free) Branches
                                        </h5>
                                        <div class="search_field">
                            <input type="text" v-model="this.search_og_unbranches" class="form-control"
                                placeholder="Search Find Branch">
 </div>
                            <div class="table-responsive">
                                <span class="m-1"></span>

                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th> Branch Name </th>
                                            <th> Action </th>
                                        </tr>
                                    </thead>
                                    <tbody id="staff-list">

                                        <tr v-for="(branch, index) in paginatedUnbranches" :key="branch.id"
                                            id="branch_{{this.id}}">
                                            <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>

                                            <td> {{ branch.name }}</td>

                                            <td>
                                                <button :disabled="loading_action" @click="manibulateBranch(branch, type = 1)" type="button"
                                                    class="btn btn-primary btn-sm">
                                                    <i class="fa fa-plus"></i> Add Branch
                                                </button>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                            <div class="pagination-wrapper">

                                <button @click="currentPage--" :disabled="currentPage === 1">
                                    Prev
                                </button>

                                <button v-for="page in totalPages" :key="page" @click="currentPage = page"
                                    :class="{ active: currentPage === page }">
                                    {{ page }}
                                </button>

                                <button @click="currentPage++" :disabled="currentPage === totalPages">
                                    Next
                                </button>

                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

        <!--receiver -->
    <div class="modal fade mobile-full-width" id="receiveModal" tabindex="-1" data-bs-backdrop="static"
        data-bs-keyboard="false" role="dialog" aria-labelledby="receiveModal" aria-hidden="true">
        <div class="modal-dialog modal-md" role="document">

            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="font-weight-bold">Parcel Service Events</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <div class="container mt-3 mb-3">
                    <div class="row">
                       
                        <div class="col-sm-12">
                            <h4 class="text-center mt-3">{{ parcel.name }}</h4>
                            <h5 id="">Sender : {{ parcel.sender_name }} - {{ parcel.sender_phone }}</h5>
                            <h5 id="">Receiver : {{ parcel.receiver_name }} - {{ parcel.receiver_phone }}</h5>
                        </div>
                        

                        <div class="col-sm-12 col-md-12">
                            <div>
                                  <div class="table-responsive">
                                <span class="m-1"></span>

                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th> Client </th>
                                            <th> Status </th>
                                            <th> Date Time </th>
                                        </tr>
                                    </thead>
                                    <tbody id="staff-list">

                                        <tr v-for="(event, index) in events" :key="event.id"
                                            id="event_{{this.id}}">
                                            <td>{{ index + 1 }}</td>
                                            <td> {{ event.client }}</td>
                                            <td>
                                                <label v-if="event.type == 1" class="badge badge-warning">Hapokei</label>
                                                <label v-if="event.type == 2" class="badge badge-danger">Hapatikani</label>
                                                <label v-if="event.type == 3" class="badge badge-primary">Kapokea</label>
                                                <label v-if="event.type == 4" class="badge badge-success">Completed</label>
                                            </td>
                                            <td>
                                                {{ event.created_at }}
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                            </div>

                             <div v-if="loading_event" class="mt-1">
                                <div class="text-center">
                                    <div class="spinner-grow text-success" role="status"></div>
                                    <div class="spinner-grow text-danger" role="status"></div>
                                    <div class="spinner-grow text-warning" role="status"></div>
                                </div>
                            </div>

                            <div v-if="user.role == 4">

                             <div class="form-group mt-3">
                                <label class="form-label">Select Client</label>
                                <select class="form-control" style="height: 50px;" v-model="client">
                                    <option value="receiver">Receiver</option>
                                    <option value="receiver">Sender</option>
                                </select>
                            </div>

                           <div class="d-flex">
                                <button type="button" :disabled="this.loading_event" @click="updateEventStatus(2)" class="btn btn-danger m-1">Hapatikani</button>
                                <button type="button" :disabled="this.loading_event" @click="updateEventStatus(1)" class="btn btn-warning m-1">Hapokei</button>
                                <button type="button" :disabled="this.loading_event" @click="updateEventStatus(3)" class="btn btn-primary m-1">Kapokea</button>
                                <button type="button" :disabled="this.loading_event" @click="updateEventStatus(4)" class="btn btn-success m-1">Completed</button>
                           </div>
                           </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import axios from "axios";

import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";


export default {
    components: {
        PriceFormat,
        PhoneFormat,
        DateFormat,

    },
    data() {
        return {
            loading: true,
            loading_action: false,
            loading_event:false,
            filter_parcel:"",
            search_og_unbranches:"",
            heading:"To Days Serviced Parcels Reports",
            parcels:[],
            og_parcels:[],
            events:[],
            parcel:{},
            fdate:"",
            tdate:"",
            staff_branches: [],
            unbranches: [],
            og_unbranches: [],
            staff: {},
            currentPage: 1,
            perPage: 12,
            currentPageP: 1,
            perPageP: 20,
            user: this.$attrs.user
        };
    },
    methods: {

            getReceiveParcel(parcel) {

            this.parcel = parcel

            const modal = bootstrap.Modal.getOrCreateInstance(
                document.getElementById("receiveModal")
            );

            modal.show();

            var service_id = parcel.id

            this.getEventStatus(service_id)
        },
              async getEventStatus(service_id){

          this.loading_event = true

          var response = await axios
              .post(this.$store.state.api_url + "/service/get-event", {service_id})
              .catch((errors) => {
                    this.loading_event = false
                  var message = "Network or Server Errors";
                  this.$toast.error(message, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {

               this.loading_event = false
               this.events = response.data.events

          } else {
                this.loading_event = false
              var message = response.data.message;
              this.$toast.error(message, { duration: 5000, dismissible: true });
          }

        },

           async filterParcels(){

             this.loading = true
          var fdate = this.fdate
          var tdate = this.tdate

          var admin = 1
         var staff_id = this.$route.params.id;

          var response = await axios
              .post(this.$store.state.api_url + "/service/filter-served-parcels", {fdate, tdate, staff_id, admin})
              .catch((errors) => {
                    this.loading = false
                  var message = "Network or Server Errors";
                  this.$toast.error(message, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {

               this.loading = false

                this.parcels = response.data.parcels;
                this.og_parcels = response.data.parcels
               
                this.heading = "Services Reports From ("+fdate+" To "+tdate+")"
             
          } else {
                this.loading = false
              var message = response.data.message;
              this.$toast.error(message, { duration: 5000, dismissible: true });
          }

        },

        goBack() {
            this.$router.go(-1);
        },
        async getIndividualServiceDetails() {

            var staff_id = this.$route.params.id;

            this.loading = true

            var response = await axios
                .post(this.$store.state.api_url + "/service/individual-services",{staff_id})
                .catch((errors) => {
                    this.loading = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                this.loading = false

                this.staff_branches = response.data.staff_branches
                this.staff = response.data.staff
                this.parcels = response.data.parcels
                this.og_parcels = response.data.parcels

            } else {
                this.loading = false

                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

          async getUnAssignedBranches() {

            var response = await axios
                .get(this.$store.state.api_url + "/service/unassigned-branches")
                .catch((errors) => {
                  
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                this.unbranches = response.data.unbranches;
                this.og_unbranches = response.data.unbranches

            } else {

                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },
 
        async manibulateBranch(branch, type = 0) {

            var staff_id = this.staff.id
            var branch_id = branch.id

            this.loading_action = true

            var response = await axios
                .post(this.$store.state.api_url+"/service/manipulate-branches",{staff_id, branch_id, type})
                .catch((errors) => {
                    this.loading_action = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                this.loading_action = false
                if(type == 0){

                    this.unbranches = [ branch,...this.unbranches];
                    this.og_unbranches = [ branch,...this.og_unbranches];

                     this.staff_branches = this.staff_branches.filter(
                        branch => branch.id !== branch_id
                    );
                }

                if(type == 1){

                    this.unbranches = this.unbranches.filter(
                        branch => branch.id !== branch_id
                    );

                     this.og_unbranches = this.og_unbranches.filter(
                        branch => branch.id !== branch_id
                    );

                    this.staff_branches = [ branch,...this.staff_branches];
                   
                }

            } else {
                this.loading_action = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++
            }
        },

        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--
            }
        },

        nextPageP() {
            if (this.currentPageP < this.totalPagesP) {
                this.currentPageP++
            }
        },

        prevPageP() {
            if (this.currentPageP > 1) {
                this.currentPageP--
            }
        },

    },
    computed: {

          paginatedParcels() {
    const start = (this.currentPageP - 1) * this.perPageP
    const end = start + this.perPageP

    return this.parcels.slice(start, end)
  },

  totalPagesP() {
    return Math.ceil(this.parcels.length / this.perPage)
  },

        paginatedUnbranches() {
            const start = (this.currentPage - 1) * this.perPage
            const end = start + this.perPage

            return this.unbranches.slice(start, end)
        },

        totalPages() {
            return Math.ceil(this.unbranches.length / this.perPage)
        },

    },
    watch: {

        search_og_unbranches(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.unbranches = this.og_unbranches
                return
            }
    
            this.unbranches = this.og_unbranches.filter(staff => {

                return (
                    (staff.name && staff.name.toLowerCase().includes(term)) ||
                    (staff.region && staff.region.toLowerCase().includes(term)) ||
                    (staff.district && staff.district.toLowerCase().includes(term)) ||
                    (staff.location && staff.location.toLowerCase().includes(term))
                )
            })
        },

       filter_parcel(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.parcels = this.og_parcels
                return
            }

            this.parcels = this.og_parcels.filter(parcel => {

                return (
                    (parcel.name && parcel.name.toLowerCase().includes(term)) ||
                    (parcel.price && parcel.price.toLowerCase().includes(term)) ||
                    (parcel.sender_name && parcel.sender_name.toLowerCase().includes(term)) ||
                    (parcel.receiver_name && parcel.receiver_name.toLowerCase().includes(term)) ||
                    (parcel.receiver_phone && parcel.receiver_phone.toLowerCase().includes(term)) ||
                    (parcel.sender_phone && parcel.sender_phone.toLowerCase().includes(term)) ||
                    (parcel.tag_name && parcel.tag_name.toLowerCase().includes(term)) ||
                    (parcel.branch_from_name && parcel.branch_from_name.toLowerCase().includes(term))  ||
                    (parcel.branch_to_name && parcel.branch_to_name.toLowerCase().includes(term)) 
                )
            })
        },

    },
    created() {
        this.$store.state.page_name = "Dashbord"
        this.getIndividualServiceDetails()
        this.getUnAssignedBranches()
    },
    mounted() {
        //$('#dashbord').attr('class', 'nav-item active');
    }
};
</script>
